import EquippedSectionBottomContent from "./bottom-content";
import EquippedSectionHeader from "./header";
import EquippedSectionTopContent from "./top-content";

const EquippedSection = () => {
  return (
    <section className="py-16 px-8 md:p-12 lg:p-24">
      <div className="flex flex-col items-center space-y-16">
        <EquippedSectionHeader />
        <EquippedSectionTopContent />
        <EquippedSectionBottomContent />
      </div>
    </section>
  );
};

export default EquippedSection;
